import React from 'react';

// shared component
import { Avatar } from '../../../../components/Avatar';
import { ListLayoutRow as Row, ListLayoutCell as Cell } from '../../../../components/ListLayout';
import { Text } from '../../../../components/Text';
import { variables } from '../../../../components/variables';

// self component
import { ItemMenu } from './Menu';
import styled from 'styled-components';

type UserMenuProps = {
    userName: string;
    userEmail: string;
};

const Styles = styled.div`
    &&& {
        overflow: hidden;
        padding: 0 !important;
        margin-bottom: -16px;

        .linkChangePassword {
            font-size: ${variables.sizes[11]};
            color: ${variables.colors['base-grey']};
            font-weight: ${variables.weight[400]};
            text-decoration: underline;

            &:hover {
                color: ${variables.colors['brand-primary-blue']};
            }
        }

        .delimiter {
            // width: 312px;
            border: 1px solid ${variables.colors['delimiter']};
        }

        .link-logout {
            width: 100%;

            .itemMenu {
                text-decoration: underline !important;
                color: ${variables.colors['brand-primary-blue']} !important;
            }
        }
    }
`;

export const UserMenu: React.FC<UserMenuProps> = ({ userName, userEmail = '' }) => {
    return (
        <Styles>
            <Row justifyContent="flex-start" marginLeft="24" marginRight="24">
                <Cell>
                    <Avatar kind="secondary">{userName}</Avatar>
                </Cell>
                <Cell marginLeft="18">
                    <Row flexDirection="column" alignItems="flex-start">
                        <Cell>
                            <Text size="12" weight="700" color="road-grey">
                                {userName}
                            </Text>
                        </Cell>

                        {userEmail.length ? (
                            <Cell>
                                <Text size="10" weight="400" color="road-grey-800">
                                    {userEmail}
                                </Text>
                            </Cell>
                        ) : null}

                        <Cell>
                            <a href="#/account" className="linkChangePassword">
                                Change password
                            </a>
                        </Cell>
                    </Row>
                </Cell>
            </Row>

            <Row marginTop="10" className="w-100">
                <Cell className="w-100">
                    <div className="delimiter w-100" />
                </Cell>
            </Row>
            <Row marginLeft="0" marginRight="-6" marginTop="8">
                <div className="link-logout">
                    <ItemMenu route="/logout" color={variables.colors['brand-primary-blue']} textDecoration="underline">
                        Sign out
                    </ItemMenu>
                </div>
            </Row>
        </Styles>
    );
};
